






















































































































































































































































































































import Vue from 'vue';
import { mapState } from 'vuex';
import { AxiosError, AxiosResponse } from 'axios';

import ItemAPI from '@/services/ItemAPI';

import Util from '@/util/Util';

import Item from '@/types/Item';
import Product from '@/types/Product';
import ProductionPeriod from '@/types/ProductionPeriod';
import ImageInfo from '@/types/ImageInfo';
import ItemInformation from '@/types/ItemInformation';
import { ProductType } from '@/types/ProductType';
import Amount from '@/types/Amount';
import Price from '@/types/Price';

const GChart = require('vue-google-charts');

import ImageDisplayer from '@/components/ImageDisplayer.vue';
import LanguageSelectorTab from '@/components/LanguageSelectorTab.vue';
import Loader from '@/components/Loader.vue';
import ImageUploader from '@/components/ImageUploader.vue';

export default Vue.extend({
    name: 'ItemEditor',

    components: {
        ImageDisplayer,
        LanguageSelectorTab,
        Loader,
        ImageUploader
    },

    props: {
        itemId: {
            type: String,
            default: ''
        }
    },

    created() {
        this.loadItems();
        if (Util.isObjectId(this.itemId)) {
            this.loadItem(this.itemId);
        } else {
            this.createNewItem();
        }
        this.itemInformation.purchasePrice = new Amount();
        this.initItem();
        this.resetPrice();
    },

    data() {
        return {
            item: new Item(),
            items: new Array<Item>(),
            price: new Price(),
            error: {
                item: '',
                itemInformation: ''
            },
            status: {
                item: '',
                itemInformation: ''
            },
            progressImages: 0,
            progressIconImage: 0,
            productType: ProductType,
            productTypeFilter: ProductType.Mug,
            successfullUpload: false,
            isLoading: '',
            isLoadingItem: false,
            isLoadingItems: false,
            isLoadingItemInformation: false,
            isSavingItem: false,
            isSavingItemInformation: false,
            itemInformation: new ItemInformation(),
            numberOfItemInformations: 1,
            selectedItemId: '',
            selectedItemInformationId: '',
            maxNumberOfItemInformations: 10,
            chartOptions: {
                chart: {
                    title: 'Prisutveckling'
                }
            },
        };
    },

    computed: {
        ...mapState(['language']),

        productsByType(): Product {
            return this.$store.getters.productsByType(this.productTypeFilter);
        },

        sortedItemInformations(): ItemInformation[] {
            return this.item.itemInformations
                .sort((current: ItemInformation, next: ItemInformation) => {
                    return new Date(next.purchaseDateTime).getTime() - new Date(current.purchaseDateTime).getTime();
                })
                .slice(0, Math.min(this.item.itemInformations.length, this.maxNumberOfItemInformations));
        },

        chartData(): any[][] {
            return [
                [ 'Datum', 'Pris' ],
                ...this.item.prices
                    .sort((a, b) => new Date(a.priceDateTime).getTime() - new Date(b.priceDateTime).getTime())
                    .map((price: Price) => [ price.priceDateTime.toString().split('T')[0], price.amount.value ])
            ];
        }
    },

    watch: {
        progressImages(val) {
            const vm = this;
            if (val === 100) {
                setTimeout(() => {
                    vm.progressImages = 0;
                    vm.successfullUpload = false;
                }, 5000);
            }
        },

        progressIconImage(val) {
            const vm = this;
            if (val === 100) {
                setTimeout(() => {
                    vm.progressIconImage = 0;
                    vm.successfullUpload = false;
                }, 5000);
            }
        }
    },

    methods: {
        move(from: number, to: number) {
            this.item.images.splice(to, 0, this.item.images.splice(from, 1)[0]);
        },

        resetPrice(): void {
            this.price.amount = new Amount();
            this.price.amount.currencyCode = 'SEK';
        },

        initItem(): void {
            this.item.itemDescription = new Map<string, string>();
            this.item.itemName = new Map<string, string>();
            this.item.price = new Amount();
            this.item.images = new Array<ImageInfo>();
            this.item.productionPeriods = new Array<ProductionPeriod>();
            this.item.originalSticker = true;
            this.item.perfectCondition = true;
        },

        createNewItem(): void {
            this.item = new Item();
            this.initItem();
        },

        saveIconImage(formData: FormData): void {
            const vm = this;
            const config = {
                onUploadProgress(progressEvent: ProgressEvent) {
                    vm.progressIconImage = progressEvent.loaded / progressEvent.total * 100;
                }
            };

            ItemAPI
                .postIconImage(this.item.itemId, formData, config)
                .then((response: AxiosResponse) => {
                    this.successfullUpload = true;
                    this.item = response.data;
                })
                .catch((error: AxiosError) => {
                    if (error.response) {
                        if (error.response.status === 413) {
                            this.error.item = 'Image was to big to upload';
                        }
                        this.error.item = error.response.data.message;
                    }
                });
        },

        deleteIconImage(): void {
            ItemAPI
                .deleteIconImage(this.item.itemId)
                .then((response: AxiosResponse) => {
                    this.successfullUpload = true;
                    this.item = response.data;
                })
                .catch((error: AxiosError) => {
                    if (error.response) {
                        if (error.response.status === 413) {
                            this.error.item = 'Image was to big to upload';
                        }
                        this.error.item = error.response.data.message;
                    }
                });
        },

        saveItem(): void {
            if (!Util.isObjectId(this.item.productId)) {
                alert('Need to specify product for sale');
                return;
            }
            const handleResponse = (response: AxiosResponse) => {
                    this.status.item = 'Saved successfully!';
                    this.createNewItem();
                    this.loadItems();
                };

            const handleError = (error: AxiosError) => {
                    if (error.response) {
                        alert(error.response.data.message);
                    }
                };

            this.item.productType = this.productTypeFilter;
            this.isSavingItem = true;
            if (this.item.itemId) {
                ItemAPI
                    .putItem(this.item.itemId, this.item)
                    .then(handleResponse)
                    .catch(handleError)
                    .finally(() => this.isSavingItem = false);
            } else {
                ItemAPI
                    .postItem(this.item)
                    .then(handleResponse)
                    .catch(handleError)
                    .finally(() => this.isSavingItem = false);
            }
        },

        deleteItem(): void {
            if (!this.item || !Util.isObjectId(this.item.itemId)) {
                alert('Need to specify item to delete');
                return;
            }
            ItemAPI
                .deleteItem(this.item.itemId)
                .then(() => this.status.item = 'Deleted successfully!')
                .catch((error: string) => this.error.item = error);
        },

        saveItemInformation(): void {
            if (!Util.isObjectId(this.item.itemId)) {
                this.error.itemInformation = 'Need to choose a Item first';
                return;
            }
            if (!this.itemInformation.purchasePrice.value) {
                this.error.itemInformation = 'Must add purchase price';
                return;
            }
            const handleResponse = (response: AxiosResponse) => {
                    this.status.itemInformation = 'Saved successfully!';
                    this.error.itemInformation = '';
                    this.numberOfItemInformations = 1;
                    this.itemInformation = new ItemInformation();
                    this.itemInformation.purchasePrice = new Amount();
                    this.loadItems();
                };

            const handleError = (error: AxiosError) => {
                    if (error.response) {
                        this.error.itemInformation = error.response.data.message;
                    }
                };

            this.isSavingItemInformation = true;
            const itemInformations = [];
            let i = 0;
            do {
                itemInformations.push(this.itemInformation);
                i++;
            }
            while (i < this.numberOfItemInformations);
            ItemAPI
                .postItemInformations(this.item.itemId, itemInformations)
                .then(handleResponse)
                .catch(handleError)
                .finally(() => this.isSavingItemInformation = false);
        },

        updateItemInformation(): void {
            if (!Util.isObjectId(this.item.itemId) &&
                !Util.isObjectId(this.itemInformation.itemInformationId)) {
                alert('Need to choose a Item and ItemInformation first');
                return;
            }
            const handleResponse = (response: AxiosResponse) => {
                    this.status.itemInformation = 'Saved successfully!';
                    const itemId = this.item.itemId;
                    this.item = new Item();
                    this.itemInformation = new ItemInformation();
                    this.itemInformation.purchasePrice = new Amount();
                    this.loadItems();
                    this.editItem(itemId);
                };

            const handleError = (error: AxiosError) => {
                    if (error.response) {
                        this.error.itemInformation = error.response.data.message;
                    }
                };

            if (this.itemInformation.soldAt === '') {
                delete this.itemInformation.soldAt;
            }
            this.isSavingItemInformation = true;
            ItemAPI
                .putItemInformation(
                    this.item.itemId,
                    this.itemInformation.itemInformationId,
                    this.itemInformation)
                .then(handleResponse)
                .catch(handleError)
                .finally(() => this.isSavingItemInformation = false);
        },

        savePrice(): void {
            if (!this.price.amount || !this.price.amount.value) {
                alert('Ange ett pris först innan du sparar.');
                return;
            }
            this.isLoading = 'Saving_New_Price';
            ItemAPI
                .postPrice(this.item.itemId, this.price)
                .then((axiosResponse: AxiosResponse) => this.item = axiosResponse.data)
                .catch((error: string) => this.error.item = error)
                .finally(() => this.isLoading = '');
        },

        loadItems(): void {
            this.isLoadingItems = true;
            ItemAPI
                .get()
                .then((axiosResponse: AxiosResponse) => this.items = axiosResponse.data)
                .catch((error: string) => this.error.item = error)
                .finally(() => this.isLoadingItems = false);
        },

        loadItem(itemId: string): void {
            this.status.item = '';
            this.status.itemInformation = '';
            this.isLoadingItem = true;
            ItemAPI
                .getItem(itemId)
                .then((response: AxiosResponse) => {
                    if (response.data) {
                        this.item = response.data;
                    }
                })
                .catch((error: AxiosError) => this.error.item = 'Unable to load item')
                .finally(() => this.isLoadingItem = false);
        },

        saveImage(formData: FormData): void {
            const vm = this;
            const config = {
                onUploadProgress(progressEvent: ProgressEvent) {
                    vm.progressImages = progressEvent.loaded / progressEvent.total * 100;
                }
            };

            ItemAPI
                .postImage(this.item.itemId, formData, config)
                .then((response: AxiosResponse) => {
                    this.successfullUpload = true;
                    this.item = response.data;
                })
                .catch((error: AxiosError) => {
                    if (error.response) {
                        if (error.response.status === 413) {
                            this.error.item = 'Image was to big to upload';
                        }
                        this.error.item = error.response.data.message;
                    }
                });
        },

        deleteImage(image: ImageInfo): void {
            ItemAPI
                .deleteImage(this.item.itemId, image.imageId)
                .then((response: AxiosResponse) => {
                    this.item = response.data;
                })
                .catch((error: AxiosError) => {
                    if (error.response) {
                        this.error.item = error.response.data.message;
                    }
                });
        },

        editItem(itemId: string): void {
            this.selectedItemId = itemId;
            this.loadItem(itemId);
            this.resetMessages();
            Util.scrollToElementWithId('item-editor');
        },

        editItemInformation(itemInformation: ItemInformation): void {
            this.selectedItemInformationId = itemInformation.itemInformationId;
            this.itemInformation = Object.assign({}, itemInformation);
            this.resetMessages();
            Util.scrollToElementWithId('itemInformation-editor');
        },

        resetMessages(): void {
            this.status.item = '';
            this.status.itemInformation = '';
            this.error.item = '';
            this.error.itemInformation = '';
        },

        itemCheck(item: Item): string {
            const errors = new Array<string>();
            if (!item.iconImage) {
                errors.push('Icon Image');
            }
            if (!item.images || item.images.length === 0) {
                errors.push('Images');
            }
            if (!item.price || item.price.value === 0) {
                errors.push('Price');
            }
            return errors.join(', ');
        },

        quantity(item: Item): number {
            return item.itemInformations.filter((info) => !info.soldDateTime).length;
        },

        numbersSold(item: Item): number {
            return item.itemInformations.filter((info) => info.soldDateTime).length;
        }
    }
});
